/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure.reducer';

export const PatientProcedureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureEntity = useAppSelector(state => state.patientProcedure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedure.detail.title">PatientProcedure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.id}</dd>
          <dt>
            <span id="plannedDate">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.plannedDate">Planned Date</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.plannedDate}</dd>
          <dt>
            <span id="performedDate">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.performedDate">Performed Date</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.performedDate}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.status">Status</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.status}</dd>
          <dt>
            <span id="statusReason">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.statusReason">Status Reason</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.statusReason}</dd>
          <dt>
            <span id="preProcedureNotes">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.preProcedureNotes">Pre Procedure Notes</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.preProcedureNotes}</dd>
          <dt>
            <span id="postProcedureNotes">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.postProcedureNotes">Post Procedure Notes</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.postProcedureNotes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.timestampentry}</dd>
          <dt>
            <span id="approved">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.approved">Approved</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.approved ? 'true' : 'false'}</dd>
          <dt>
            <span id="approvedStatus">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.approvedStatus">Approved Status</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.approvedStatus}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.addedByType}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.addedById}</dd>
          <dt>
            <span id="outcome">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.outcome">Outcome</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.outcome}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.patientProcedure.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEntity.patientType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedure.surgeon">Surgeon</Translate>
          </dt>
          <dd>{patientProcedureEntity.surgeon ? patientProcedureEntity.surgeon.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedure.anaesthesiologist">Anaesthesiologist</Translate>
          </dt>
          <dd>{patientProcedureEntity.anaesthesiologist ? patientProcedureEntity.anaesthesiologist.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedure.patient">Patient</Translate>
          </dt>
          <dd>{patientProcedureEntity.patient ? patientProcedureEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedure.procedure">Procedure</Translate>
          </dt>
          <dd>{patientProcedureEntity.procedure ? patientProcedureEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedure.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{patientProcedureEntity.treatmentPlan ? patientProcedureEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedure.prescription">Prescription</Translate>
          </dt>
          <dd>{patientProcedureEntity.prescription ? patientProcedureEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedure.orderItem">Order Item</Translate>
          </dt>
          <dd>{patientProcedureEntity.orderItem ? patientProcedureEntity.orderItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure/${patientProcedureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureDetail;
